export default __webpack_public_path__ + "fea73e6646b2974fe45058ae610102e5.svg";